import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";
import appReducer from "./reducers/appSlice";
import characterReducer from './reducers/characterSlice';
import roominvitationReducer from './reducers/roominvitationSlice';


export default configureStore({
  reducer: {
    user: userReducer,
    app: appReducer,
    character: characterReducer,
    roominvitation: roominvitationReducer
  },
});